export default __webpack_public_path__ + "static/media/RosanaRodrigues_04.609efd7e.jpg";